var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"iconic-button pointer"},'button',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"material-icons iconic-button__icon"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('span',{staticClass:"iconic-button__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }